
import { React, useEffect, useState } from "react";
// import { BarChart, BarChart2, ClipboardList, User2 } from 'lucide-react';
import img1 from '../../assets/images/money.png'
import img2 from '../../assets/images/3533397_clients_customer_market_marketing_segment_icon 1.png'
import img3 from '../../assets/images/4753735_analysis_analytics_business_chart_diagram_icon 1.png'
import img4 from '../../assets/images/9044563_inventory_management_icon 1.png'
import "./recentlist.scss";
import { Link } from "react-router-dom";
import { fetchReportData } from "../../services/fetchReportData";
// import { ReportCard } from "./ReportCard";
// import { CustomLoader } from "../Loader";
import RecentReports from "./ListTable";

const RecentList = () => {
  const userToken = localStorage.getItem("user_token");
  const [loading, setLoading] = useState(false);

  const images = [img1, img2, img3, img4];
  const [category, setCategory] = useState([]);
  const [CategoryData, setCategoryData] = useState([])

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const data = await fetchReportData(userToken);
        let temp = data?.message?.categories?.filter(item => item?.count > 0)?.map((item) => item?.category)
        setCategoryData(data?.message?.categories);
        setCategory(temp);
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.error('Error fetching report data:', error);
      }
    };

    getData();
  }, [userToken]);

  const data = [
    {
      title: 'Total Reports',
      value: 75,
      percent: '+12%',
      icon: '📈',
    },
    {
      title: 'Active Reports',
      value: 68,
      percent: '+12%',
      icon: '✅',
    },
    {
      title: 'Reports Viewed',
      value: 18,
      percent: '+12%',
      icon: '👁️',
    },
  ];
  return (


    <div className="dashboard-layout">
      <div className="main-content">
        <div>
          <div className="layout-container">
            {/* Content Section */}
            <div className="content">
              <div className="dashboard">
                <section className="section recent-visit">
                  <div className="box">
                    <div className="headers">
                      <h2>Recent Visit</h2>
                      <Link to={"/dashboard/category/list"} >
                        <h4>View All Reports</h4>
                      </Link>
                    </div>

                    {/* table */}
                    <RecentReports />
                  </div>
                </section>
                {/* <div>
                  <div className="analytics-container">
                    <div className="analytics-header">
                      <h2>Analytics Overview</h2>
                    </div>
                    <div className="cards-container">
                      {data.map((item, idx) => (
                        <div key={idx} className="analytics-card">
                          <div className="card-header">
                            <span>{item.title}</span>
                            <span className="icon">{item.icon}</span>
                          </div>
                          <div className="card-body">
                            <h3>{item.value}</h3>
                            <p className="percent">{item.percent} <span>from last month</span></p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div> */}
                

                <div>
                </div>
              </div>
            </div>
          </div>

        </div>



      </div>
    </div>
  );
};

export default RecentList;
